import { makeObservable, reaction } from 'mobx';

import { OneSignalService } from '../../services/oneSignal.service';
import { OptimoveService } from '../../services/optimove.service';
import { type RootStore } from '../RootStore';
import { Loadable } from '../traits/Loadable';

export class NotificationsStore extends Loadable {
  root: RootStore;

  constructor(_rootStore: RootStore) {
    super();
    makeObservable(this);
    this.root = _rootStore;

    // Initialize and log in to OneSignal/Optimove only after the user is authenticated
    reaction(
      () => this.root.authStore.authorized && !!this.root.userStore.profile?.firebaseUid,
      (isAuthenticated) => {
        const { firebaseUid } = this.root.userStore.profile ?? {};
        if (isAuthenticated && firebaseUid) {
          void OneSignalService.init().then(() => OneSignalService.login(firebaseUid));
          void OptimoveService.init().then(() => OptimoveService.login(firebaseUid));
        } else if (!this.root.authStore.authorized) {
          void OptimoveService.logout();
        }
      },
    );

    // Show notification prompt when user completes onboarding
    reaction(
      () => this.root.onboardingStore.finishedFtue,
      (showNotificationPrompt) => {
        if (showNotificationPrompt) {
          void OneSignalService.promptPush();
          void OptimoveService.requestPushPermission();
        }
      },
    );
  }
}
